// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import index from './components/index'
import Mock from './mock'
Mock.bootstrap()

import elmentUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(elmentUI)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  //components: { App },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js